import React, { useState } from "react";
import { Link } from "react-router-dom";
import PropTypes from "prop-types";

import {
  Dialog,
  DialogTitleActions,
  Type,
  ListItem,
  Anchor,
} from "discover.medical.react-component-library";
import {
  StyledWrapper,
  StyledButton,
  StyledDialogTitle,
  StyledDialogContent,
  StyledList,
} from "./_.styled";

const AboutCMElink = ({ productName }) => {
  const [isDialogOpen, setDialogOpen] = useState(false);
  return (
    <StyledWrapper>
      <StyledButton kind="anchor" onClick={() => setDialogOpen(true)}>
        About CME
      </StyledButton>
      <Dialog
        isOpen={isDialogOpen}
        maxWidth="md"
        aria-labelledby="about-cme-dialog-title"
      >
        <StyledDialogTitle id="about-cme-dialog-title">
          <Type element="h2" fontFamily="secondary">
            About CME
          </Type>
          <DialogTitleActions onRequestClose={() => setDialogOpen(false)} />
        </StyledDialogTitle>
        <StyledDialogContent>
          <Type element="p" fontWeight="semibold" marginBottom="sm">
            {`${productName} offers a comprehensive suite of point-of-care topics,
            with a unified set of learning goals and objectives that applies to
            all topics.`}
          </Type>
          <Type element="p" marginBottom="sm">
            The goal of the educational activities is to improve clinical
            decision-making and associated patient care outcomes by providing
            physicians and nurse practitioners with questions.
          </Type>
          <Type element="p" marginBottom="sm">
            As a result of the activities, the participant will be able to:
          </Type>
          <StyledList columns={1} type="ul">
            <ListItem>
              Access and apply validated information that can enhance their
              decision-making in specific instances of diagnosis and treatment.
            </ListItem>
            <ListItem>
              Engage in structured, self-directed reflection on the question,
              the evidence, and the application of information to a particular
              clinical case.
            </ListItem>
          </StyledList>
          <Anchor href="/cme-about" linkComponent={Link}>
            Learn more about CME/CPD/CE and MOC
          </Anchor>
        </StyledDialogContent>
      </Dialog>
    </StyledWrapper>
  );
};

AboutCMElink.propTypes = {
  productName: PropTypes.string.isRequired,
};
AboutCMElink.displayName = "AboutCMElink";
export default AboutCMElink;
